module.exports = __webpack_public_path__ + "static/media/hero_img.c188d09b.png";